module.exports = __webpack_public_path__ + "static/aicon-34371e901999fc54089ea9e94c4e810f.png";